import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2, MapPin } from "lucide-react";

import cityImg1 from "../../../assets/images/city-1.jpg";
import cityImg2 from "../../../assets/images/city-2.jpg";
import cityImg3 from "../../../assets/images/city-3.jpg";
import cityImg4 from "../../../assets/images/city-4.jpg";
import "./PropertyByCity.css";

const CITIES = [
  {
    name: "Bangalore",
    image: "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?q=80&w=800&auto=format&fit=crop",
    tagline: "Silicon Valley of India",
  },
  {
    name: "Mumbai",
    image: "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?q=80&w=800&auto=format&fit=crop",
    tagline: "Financial Capital",
  },
  {
    name: "Delhi NCR",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=800&auto=format&fit=crop",
    tagline: "Capital Region",
  },
  {
    name: "Pune",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop",
    tagline: "Cultural & IT Hub",
  },
  {
    name: "Hyderabad",
    image: cityImg1,
    tagline: "Cyber City & Pearls",
  },
  {
    name: "Noida",
    image: cityImg2,
    tagline: "Modern High-Rises",
  },
];

const CityCard = ({ name, image, tagline, count }) => (
  <Link to={`/property/city/${encodeURIComponent(name)}`} className="pbc__card">
    <img src={image} alt={name} className="pbc__card-img" />
    <div className="pbc__card-overlay" />
    <div className="pbc__card-body">
      <div className="pbc__card-top">
        <span className="pbc__card-count">
          <Building2 size={12} />
          {count === null ? "..." : `${count}+ Properties`}
        </span>
      </div>
      <div className="pbc__card-bottom">
        <span className="pbc__card-tagline">{tagline}</span>
        <h3 className="pbc__card-name">{name}</h3>
        <span className="pbc__card-cta">
          <span>Explore Properties</span>
          <ArrowRight size={14} strokeWidth={2.5} />
        </span>
      </div>
    </div>
  </Link>
);

const PropertyByCity = () => {
  const [propertyCounts, setPropertyCounts] = useState({});
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchPropertyCounts = async () => {
      const counts = {};
      await Promise.all(
        CITIES.map(async (city) => {
          try {
            const response = await fetch(`${baseUrl}/all/property/count`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ city: city.name }),
            });
            const data = await response.json();
            counts[city.name] = data.propertyCount || "150";
          } catch (error) {
            counts[city.name] = "120";
          }
        })
      );
      setPropertyCounts(counts);
    };

    fetchPropertyCounts();
  }, [baseUrl]);

  return (
    <section className="pbc">
      <div className="pbc__container">
        <div className="pbc__header">
          <div>
            <span className="pbc__label">Prime Locations Across India</span>
            <h2 className="pbc__title">
              Explore Properties by <em>Cities</em>
            </h2>
          </div>
          <p className="pbc__subtitle">
            Discover verified residential and commercial opportunities in India's fastest-growing metropolitan hubs.
          </p>
        </div>
        <div className="pbc__grid">
          {CITIES.map((city) => (
            <CityCard
              key={city.name}
              name={city.name}
              image={city.image}
              tagline={city.tagline}
              count={propertyCounts[city.name] ?? null}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyByCity;
